const categoria = (state) => {
  return state.categoria
}

const nome = (state) => {
  return state.nome
}

const dadosBasicos = (state) => {
  return state.dadosBasicos
}

const descricao = (state) => {
  return state.descricao
}

const linguaList = (state) => {
  return state.linguaList
}

const habilidadeList = (state) => {
  return state.habilidadeList
}

const formacaoAcademicaList = (state) => {
  return state.formacaoAcademicaList
}

const historicoProfissionalList = (state) => {
  return state.historicoProfissionalList
}

const linguaGroup = (state) => {
  return state.linguaGroup
}

const habilidadeGroup = (state) => {
  return state.habilidadeGroup
}

const tipoEmpresa = (state) => {
  return state.tipoEmpresa
}

const ramoAtividade = (state) => {
  return state.ramoAtividade
}

const dadosBasicosValidation = (state) => {
  return state.dadosBasicosValidation
}
const descricaoValidation = (state) => {
  return state.descricaoValidation
}
const linguaListValidation = (state) => {
  return state.linguaListValidation
}
const habilidadeListValidation = (state) => {
  return state.habilidadeListValidation
}

export default {
  categoria,
  nome,
  dadosBasicos,
  descricao,
  linguaList,
  habilidadeList,
  formacaoAcademicaList,
  historicoProfissionalList,
  linguaGroup,
  habilidadeGroup,
  tipoEmpresa,
  ramoAtividade,
  dadosBasicosValidation,
  descricaoValidation,
  linguaListValidation,
  habilidadeListValidation
}



// WEBPACK FOOTER //
// ./src/features/vp/curriculo/cadastro/store/getters.js